/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessmanagement1Inputs */

const en_businessmanagement1 = /** @type {(inputs: Businessmanagement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Management`)
};

const de_businessmanagement1 = /** @type {(inputs: Businessmanagement1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensverwaltung`)
};

/**
* | output |
* | --- |
* | "Business Management" |
*
* @param {Businessmanagement1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessmanagement1 = /** @type {((inputs?: Businessmanagement1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessmanagement1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessmanagement1(inputs)
	return de_businessmanagement1(inputs)
});
export { businessmanagement1 as "businessManagement" }